import {Injectable} from '@angular/core';
import {AppSettings} from '../../../settings/app-settings';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {TGiftVoucherLedger} from '../model/t-gift-voucher-ledger';

@Injectable()
export class TransactionSummaryDashboardService {

  constructor(private http: HttpClient) {
  }

  public getSummaryDashboardDetails(trasactionType: string, barcode: string): Observable<TGiftVoucherLedger[]> {
    return this.http.get<TGiftVoucherLedger[]>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/dashboard/find-summary-dashboard/' + trasactionType +"/" +barcode);
  }

}



// WEBPACK FOOTER //
// ./src/app/view/dashboard/transaction-summary-dashboard/service/transaction-summary-dashboard.service.ts